export default __webpack_public_path__ + "static/media/AIdemos_old.bb3c3173.jpeg";